import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const removeLoadingSplash = (): void => {
    const el = document.getElementById('loading');
    if (el) {
        el.className = 'loaded';
        setTimeout(() => {
            el.remove();
        }, 500);
    }
};

const canAccessLocalStorage = (): boolean => {
    try {
        localStorage.getItem('Test');
        return true;
    } catch (err) {
        return false;
    }
};

const getNode = (): React.JSX.Element => {
    if (!canAccessLocalStorage()) {
        return (
            <div style={{ margin: '8px' }}>
                Browser configuration is currently not supported. Please enable cookies and website data or try another
                browser.
            </div>
        );
    }

    return (
        <StrictMode>
            <App />
        </StrictMode>
    );
};

(async () => {
    const node = getNode();

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    createRoot(document.getElementById('root')!).render(node);
    removeLoadingSplash();
})().catch((e) => {
    if (!process.env.STORYBOOK) {
        console.log('Failed to render app', e);
        alert('Failed to initiate app, please contact support.');
    }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
